import axios from 'axios'
import { auth } from '@/services/'

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 5 * 60 * 1e3
})

// intercept http request
instance.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem('accessToken');

    if (token) {
      config.headers['authorization'] = token;
    }
    config.headers['Content-Type'] = 'application/json';

    return config;
  },

  (error) => {
    console.log(error)
    return Promise.reject(error);
  }
)

// intercept http response
instance.interceptors.response.use(
  (response) => {
    return response
  },

  (error) => {
    if (error.response) {
      if (error.response.status === 403 && error.response.data.msgOn === 'Verify Token') {
        auth.redirect()
        return
      } else if (error.response.status === 404) {
        // BE return 404 if data is empty,
        // we have to assign "data" prop with empty array
        error.response.data.msgContent = {}
        error.response.data.msgContent['data'] = []
        return Promise.resolve(error.response)
      } else {
        // Do something with response error
        return Promise.reject(error)
      }
    }
  }
)

const server = {
  get: (url, params) => {
    return instance.get(url, { params: params })
  },
  post: (url, payload, config) => {
    return instance.post(url, payload, config)
  },
  patch: (url, payload) => {
    return instance.patch(url, payload)
  },
  delete: (url) => {
    return instance.delete(url)
  }
}

export default server;
